document.addEventListener('DOMContentLoaded', function () {

  /* Header scroll state (kept for parity with the static build; header is
     already opaque parchment, so this currently only exists as a hook for
     a future subtle shadow/elevation state if the design calls for one). */
  var header = document.getElementById('siteHeader');
  var lastScrolled = false;
  window.addEventListener('scroll', function () {
    var scrolled = window.scrollY > 40;
    if (scrolled !== lastScrolled && header) {
      header.classList.toggle('scrolled', scrolled);
      lastScrolled = scrolled;
    }
  }, { passive: true });

  /* Mobile nav drawer */
  var navToggle = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');
  var siteHeader = document.getElementById('siteHeader');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.classList.toggle('open');
      if (open && siteHeader) {
        /* Header height varies when the optional announcement bar is on,
           so measure it at open time rather than assuming a fixed value. */
        mobileNav.style.top = siteHeader.getBoundingClientRect().bottom + 'px';
      }
      mobileNav.classList.toggle('open', open);
      navToggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('.mobile-group-title[data-toggle]').forEach(function (el) {
      el.addEventListener('click', function () {
        var sub = document.getElementById('sub-' + el.dataset.toggle);
        if (sub) sub.classList.toggle('open');
      });
    });
  }

  /* Quantity selectors (PDP) */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    var display = wrap.querySelector('[data-qty-value]');
    var dec = wrap.querySelector('[data-qty-decrease]');
    var inc = wrap.querySelector('[data-qty-increase]');

    function setQty(val) {
      val = Math.max(1, val);
      input.value = val;
      display.textContent = val;
    }
    dec.addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
    inc.addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
  });

  /* Collection sort — preserves any active filter params already in the URL */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

});
